import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useForm } from '../context/FormContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiRefreshCw } = FiIcons;

function Header() {
  const { resetForm, getProgress } = useForm();
  const navigate = useNavigate();

  const handleClearForm = () => {
    if (window.confirm('Are you sure you want to clear all form data? This action cannot be undone.')) {
      resetForm();
      navigate('/step/1');
    }
  };

  const steps = [
    { number: 1, title: 'Business Info', subtitle: '' },
    { number: 2, title: 'Design', subtitle: '' },
    { number: 3, title: 'Branding', subtitle: '' },
    { number: 4, title: 'Content', subtitle: '' },
    { number: 5, title: 'Audience', subtitle: '' },
    { number: 6, title: 'Technical', subtitle: '' },
    { number: 7, title: 'Review', subtitle: '' }
  ];

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a
              href="https://www.primehost.co.za/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center"
            >
              <img
                src="https://media.phst.co.za/file/ph/primehost-logo-800.png"
                alt="Primehost"
                className="h-10 w-auto"
              />
            </a>
          </div>

          {/* Step Navigation Menu */}
          <nav className="hidden md:flex space-x-1 overflow-x-auto ml-auto">
            {steps.map((step) => (
              <NavLink
                key={step.number}
                to={`/step/${step.number}`}
                end
                className={({ isActive }) =>
                  `step-menu-item${isActive ? ' step-menu-active' : ''}`
                }
              >
                <div>{step.title}</div>
                {step.subtitle && <div className="text-sm">{step.subtitle}</div>}
              </NavLink>
            ))}
          </nav>

          {/* Clear Form Button */}
          <div className="flex items-center space-x-4 ml-8">
            <button
              onClick={handleClearForm}
              className="flex items-center space-x-2 px-4 py-2 bg-[#ED4145] text-white rounded-lg hover:bg-[#D6393D] transition-colors duration-200"
            >
              <SafeIcon icon={FiRefreshCw} className="h-4 w-4 text-white" />
              <span className="text-base font-medium">Clear form</span>
            </button>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="pb-4">
          <div className="flex justify-end items-center">
            <span className="text-base font-medium text-gray-900">
              {getProgress()}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-gradient-to-r from-[#FF5841] to-[#008080] h-2 rounded-full transition-all duration-300"
              style={{ width: `${getProgress()}%` }}
            ></div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;